import {useCodes} from "hooks/StateHooks"
import _ from 'lodash'

export const make = (make: number) => {
  return _.get(_.find(_.get(useCodes(), 'Make', []), {value: make}), 'label', '-')
}
export const model = (make: number, model: number) => {
  return _.get(_.find(_.get(useCodes(), 'Model.' + make), {value: model}), 'label', '-')
}
export const vehicleAttribute = (field: string, value: string | number) => {
  let attribute = _.get(useCodes(), field, {})
  return _.get(_.find(attribute, {value: value}), 'label', '-')
}
